import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './components/layout/global.css';

// ۱. کامپوننت‌های لایوت و صفحات
import AppLayout from './components/layout/AppLayout';
import HomePage from './pages/HomePage';
import Library from './pages/LibraryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PDFViewerPage from './pages/PDFViewerPage';
import BookDetail from './pages/BookDetail';
import BookListPage from './pages/BookListPage';
import SubCategoriesPage from './pages/SubCategoriesPage';
import TagProductsPage from './pages/TagProductPage';
import ProductSummaryPage from './pages/ProductSummaryPage';
import ContentTypeProductsPage from './pages/ContentTypeProductsPage';
import ProductListPage from './pages/ProductListPage';
import CategoriesPage from './pages/CategoriesPage';

// صفحات پروفایل
import ProfilePage from './pages/ProfilePage';
import { EditProfileScreen } from './components/profile-components/EditProfileScreen';
import FavoritesFullPage from './pages/FavoritesFullPage';
import HistoryPage from './pages/HistoryPage';
import PurchasedPage from './pages/PurchasePage';

// صفحات کیف پول، کارت هدیه، تخفیف، داوطلب و ارجاع
import WalletPage from './pages/WalletPage';
import GiftCardPage from './pages/GiftCardPage';
import DiscountsPage from './pages/DiscountsPage';
import VolunteerApplicationPage from './pages/VolunteerApplicationPage';
// صفحات جدید (کمک مالی و قوانین)
import DonatePage from './pages/DonatePage';
import RulesPage from './pages/RulesPage';

// ۲. ایمپورت Providers و AuthModal
import { AuthProvider } from './context/AuthContext';
import { PlayerProvider } from './context/PlayerContext';
import AuthModal from './components/common/AuthModal';
import ChargeRequestModal from './components/wallet/ChargeRequestModal';
import GiftCardPaymentModal from './components/wallet/GiftCardPaymentModal';
import GiftCardReceiverPage from './pages/GiftCardReceiverPage';
import MediaSummaryPage from './pages/MediaSummaryPage';

// ✅ صفحه جدید (جایگزین دانلودها)
import AuthorWorksPage from './pages/AuthorWorksPage';

// ✅ اضافه شد: صفحه هوش مصنوعی
import AIPage from './pages/AIPage';

// 🆕 صفحه نتیجهٔ پرداخت (عمومی)
import PaymentResultPage from './pages/PaymentResultPage';

// کامپوننت‌های درجا (به جز Downloads که حذف شده)
const NotFoundPage = () => <h1>404 - صفحه مورد نظر یافت نشد</h1>;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
   <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <PlayerProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* مسیرهای اصلی (داخل قالب AppLayout) */}
              <Route path="/" element={<AppLayout />}>
                <Route index element={<HomePage />} />

                <Route path="products/list" element={<ProductListPage />} />

                <Route path="books" element={<BookListPage />} />
                <Route path="books/:slug" element={<BookDetail />} />

                <Route path="products/list/tag/:tagSlug" element={<TagProductsPage />} />
                <Route path="products/by-content-type/" element={<ContentTypeProductsPage />} />
                <Route path="products/list/:categorySlug/:subcategorySlug" element={<SubCategoriesPage />} />
                <Route path="products/list/:categorySlug" element={<SubCategoriesPage />} />
                <Route path="products/:categorySlug/:subcategorySlug/:slug" element={<ProductDetailPage />} />
                <Route path="products/:categorySlug/:slug" element={<ProductDetailPage />} />
                <Route path="products/:slug" element={<ProductDetailPage />} />
                <Route path="products/:slug/summary" element={<ProductSummaryPage />} />
                <Route path="/media-summary/:mediaId" element={<MediaSummaryPage />} />

                {/* ✅ مسیر دسته‌بندی اصلی محصولات */}
                <Route path="categories" element={<CategoriesPage />} />

                <Route path="profile" element={<ProfilePage />} />
                <Route path="profile/edit" element={<EditProfileScreen />} />
                <Route path="profile/favorites" element={<FavoritesFullPage />} />
                <Route path="profile/volunteer" element={<VolunteerApplicationPage />} />
                <Route path="profile/history" element={<HistoryPage />} />
                <Route path="profile/purchased" element={<PurchasedPage />} />
                <Route path="profile/donate" element={<DonatePage />} />
                <Route path="profile/rules" element={<RulesPage />} />

                <Route path="profile/wallet" element={<WalletPage />} />
                <Route path="wallet" element={<WalletPage />} />   {/* 🆕 مسیر کیف پول از طریق /wallet */}
                <Route path="profile/gift-card" element={<GiftCardPage />} />
                <Route path="profile/discounts" element={<DiscountsPage />} />

                {/* ✅ مسیر دانلودها به صفحه جدید هدایت می‌شود */}
                <Route path="Malekian" element={<AuthorWorksPage />} />
                <Route path="library" element={<Library />} />

                {/* ✅ اضافه شد: مسیر صفحه هوش مصنوعی */}
                <Route path="ai-assistant" element={<AIPage />} />
              </Route>

              {/* ========= مسیرهای بدون لایوت (عمومی) ========= */}
              <Route path="/giftcard/:uuid" element={<GiftCardReceiverPage />} />
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/pdf-viewer" element={<PDFViewerPage />} />
              <Route path="/payment-result" element={<PaymentResultPage />} />   {/* 🆕 نتیجهٔ پرداخت */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <AuthModal />
          </BrowserRouter>
        </AuthProvider>
      </PlayerProvider>
    </QueryClientProvider>
    </HelmetProvider> 
  );
};

export default App;